import Swiper from "swiper";
import { Pagination } from "swiper/modules";

(function () {
  const swiperSlider = document.querySelectorAll(".mb-event-card-slider");
  let imageSwiper = [];
  const standardSlidesPerView = 1;

  for (let i = 0; i < swiperSlider.length; i++) {
    const slidesMax = swiperSlider[i].dataset.slidesMax ?? 3;

    const paginationEl = swiperSlider[i].querySelector('.swiper-pagination');

    imageSwiper[i] = new Swiper(swiperSlider[i], {
      modules: [Pagination],
      slidesPerView: standardSlidesPerView,
      spaceBetween: 20,
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      on: {
        init: function (swiper) {
          adjustSlidesOpacity(swiper.slides, standardSlidesPerView);
        },
        breakpoint: function (swiper, breakpointParams) {
          adjustSlidesOpacity(swiper.slides, standardSlidesPerView);
        },
        beforeTransitionStart: function (swiper) {
          adjustSlidesOpacity(swiper.slides, standardSlidesPerView);
        },
      },
    });
  }
})();

function adjustSlidesOpacity(slideElementsArray, slidesPerView) {
  if (slidesPerView >= 2) {
    slideElementsArray.forEach((el) => {
      el.style.opacity = 0;
    });
    const activeElement = slideElementsArray.find((el) => {
      return el.classList.contains("swiper-slide-active");
    });

    if (getElementExists(activeElement)) {
      activeElement.style.opacity = 1;

      setSiblingsOpacity(activeElement, slidesPerView - 1);
    }

    return;
  } else {
    slideElementsArray.forEach((el) => {
      el.style.opacity = 1;
    });
  }
}

function setSiblingsOpacity(el, siblings) {
  if (siblings < 1) {
    return;
  }

  if (el.nextElementSibling) {
    el.nextElementSibling.style.opacity = 1;

    setSiblingsOpacity(el.nextElementSibling, siblings - 1);
  } else {
    return;
  }
}
